import React, { useState } from 'react';
import { MenuItem, Popover } from '@mui/material';
var NodeMenuItemPopover = function (_a) {
    var label = _a.label, closeMenu = _a.closeMenu, children = _a.children;
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleOpen = function (e) {
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
        closeMenu === null || closeMenu === void 0 ? void 0 : closeMenu();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { onClick: handleOpen }, label),
        React.createElement(Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            }, PaperProps: {
                className: 'interactiveNode__popover',
            } }, children)));
};
export default NodeMenuItemPopover;
//# sourceMappingURL=NodeMenuItemPopover.js.map